import { render, staticRenderFns } from "./EventsList.vue?vue&type=template&id=772e0c06&scoped=true"
import script from "./EventsList.vue?vue&type=script&lang=js"
export * from "./EventsList.vue?vue&type=script&lang=js"
import style0 from "./EventsList.vue?vue&type=style&index=0&id=772e0c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772e0c06",
  null
  
)

export default component.exports